module.exports = __webpack_public_path__ + "img/ch30.0800a295.jpg";